// ? application routes
import type { RouteRecordName, RouteRecordRaw } from 'vue-router';
import home from '@/modules/home/router';
import policy from '@/modules/policy/router';
import alertAndNotification from '@/modules/AlertAndNotification/router';
import documents from '@/modules/documents/router';
import childrider from '@/modules/childrider/router';
import investments from '@/modules/investments/router';
import debtsolutions from '@/modules/debtsolutions/router';
import myRep from '@/modules/myRep/router';
import error from '@/modules/error/router';
import reinstatement from '@/modules/Reinstatement/router';
import minorsAccountLink from '@/modules/minorAccountLinkProcess/router';
import loginRoutes from '@/modules/login/router';
import appShellRoutes from '@/router/appShell.routes';
import { RouteNames } from './routeNames';
import rootPathRedirect from './navigationGuards/rootPathRedirect';
import catchAllRoute from './catchAll.route';
import { BootstrapGuard } from './navigationGuards/bootstrapGuard';

const routes: readonly RouteRecordRaw[] = [
  {
    path: '',
    redirect: rootPathRedirect,
  },
  appShellRoutes,
  loginRoutes,
  home,
  error,
  policy,
  alertAndNotification,
  documents,
  debtsolutions,
  investments,
  myRep,
  childrider,
  reinstatement,
  minorsAccountLink,
  catchAllRoute,
];

const NON_BOOTSTRAP_ROUTES = ['/error', '/login', '/app'];
const NO_AUTH_REQUIRED_ROUTES: RouteRecordName[] = [
  RouteNames.ERROR,
  RouteNames.ERROR_LAYOUT,
  RouteNames.LOGIN_SHELL,
  RouteNames.PAGE_NOT_FOUND,
  RouteNames.APP_UPDATE,
  RouteNames.UNSUPPORTED_BROWSER,
  RouteNames.MAINTENANCE_MODE,
  RouteNames.POST_LOGOUT,
];
routes.forEach((r: RouteRecordRaw) => {
  const doesRouteNeedBootstrap = !NON_BOOTSTRAP_ROUTES.includes(r.path);
  const doesRouteNeedAuthentication = !NO_AUTH_REQUIRED_ROUTES.includes(r.name);
  if (doesRouteNeedBootstrap) {
    r.beforeEnter = BootstrapGuard;
  }
  if (doesRouteNeedAuthentication) {
    const meta = { ...r.meta, requiresAuth: true };
    r.meta = meta;
  }
});
export default routes;
